// ----------------------------------------------------------------------

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({
  sm,
  md,
  lg,
}: {
  sm: number;
  md: number;
  lg: number;
}) {
  return {
    "@media (min-width:600px)": { fontSize: pxToRem(sm) },
    "@media (min-width:900px)": { fontSize: pxToRem(md) },
    "@media (min-width:1200px)": { fontSize: pxToRem(lg) },
  };
}

// ----------------------------------------------------------------------

export const FONT_PRIMARY = '"Sharp Sans",sans-serif';
export const FONT_SECONDARY = '"Mulish", sans-serif';

export const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  // H1 - Hero
  h1: {
    fontWeight: 700,
    lineHeight: 1.4,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 48, lg: 60 }),
  },
  // H2 - Section titles
  h2: {
    fontWeight: 700,
    lineHeight: 1.4,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 24, md: 32, lg: 40 }),
  },
  // Pricing
  h3: {
    fontWeight: 700,
    lineHeight: 1.4,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 32, lg: 32 }),
  },
  // H4 - Stepper title
  h4: {
    fontWeight: 700,
    fontFamily: FONT_PRIMARY,
    lineHeight: 1.4,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 18, md: 20, lg: 24 }),
  },
  // Why-trackmate cards title
  h5: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  // Cart
  h6: {
    fontWeight: 700,
    lineHeight: 28 / 18,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  // Subtitle
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.4,
    fontFamily: FONT_SECONDARY,
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ sm: 16, md: 18, lg: 18 }),
  },
  // Industry subtitle
  subtitle2: {
    fontWeight: 500,
    lineHeight: 1.4,
    fontFamily: FONT_SECONDARY,
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ sm: 14, md: 18, lg: 18 }),
  },
  // Main Text
  body1: {
    fontWeight: 500,
    lineHeight: 1.4,
    fontFamily: FONT_SECONDARY,
    fontSize: pxToRem(14),
    ...responsiveFontSizes({ sm: 14, md: 16, lg: 16 }),
  },
  body2: {
    fontWeight: 500,
    lineHeight: 22 / 14,
    fontFamily: FONT_SECONDARY,
    fontSize: pxToRem(14),
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  button: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
    lineHeight: 1.38,
    fontSize: pxToRem(16),
  },
};
